<template>
  <LibraryListItem class="pa-4">
    <div class="text-h2 text-textDarkest">
      {{ title }}
    </div>

    <div class="text-h2 text-textLighter w-100 d-flex justify-space-between">
      <div>
        {{ jobCode }}
      </div>
      <div>
        {{ location }}
      </div>
      <div>
        {{ jobLevel }}
      </div>
    </div>
  </LibraryListItem>
</template>

<script setup>
import LibraryListItem from '@/components/shared/LibraryListItem.vue';

defineProps({
  title: { type: String, default: '' },
  location: { type: String, default: '' },
  jobLevel: { type: String, default: '' },
  jobCode: { type: String, default: '' },
});
</script>

<style lang="less" scoped>
.document-list-item {
  grid-template-columns: repeat(2, 1fr);
}
</style>
